var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fix-padding", attrs: { fluid: "" } },
    [
      _vm.userGoal
        ? [
            _vm.mobile
              ? _c(
                  "div",
                  { staticClass: "p-1", style: { width: "100%" } },
                  [
                    _c("GoalSummary", { attrs: { userGoal: _vm.userGoal } }),
                    _vm._v(" "),
                    _c("UserGoalSuggestion", {
                      staticClass: "mt-3",
                      attrs: { userGoal: _vm.userGoal },
                    }),
                    _vm._v(" "),
                    _vm.schoolSetting.useAiChatLesson
                      ? _c(
                          "section",
                          {
                            staticClass:
                              "lessonComment container bg-white border border-primary rounded-3 mt-3 p-3",
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "modal fade lessonTabModal",
                                attrs: {
                                  id: "ai_chat",
                                  tabindex: "-1",
                                  "aria-labelledby": "AIチャット",
                                  "aria-hidden": "true",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "modal-dialog slideUpModal modal-dialog-scrollable modal-fullscreen bg-white",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "modal-content" },
                                      [
                                        _vm._m(1),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "modal-body pe-5" },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { xs12: "" } },
                                              [
                                                _c(
                                                  "v-tabs",
                                                  {
                                                    model: {
                                                      value: _vm.tab,
                                                      callback: function ($$v) {
                                                        _vm.tab = $$v
                                                      },
                                                      expression: "tab",
                                                    },
                                                  },
                                                  [
                                                    _vm.userGoal.id &&
                                                    _vm.schoolSetting
                                                      .useAiChatGoal
                                                      ? _c(
                                                          "v-tab",
                                                          { key: "chat" },
                                                          [_vm._v("チャット")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.userGoal.id &&
                                                    _vm.schoolSetting
                                                      .useAiChatGoal
                                                      ? _c(
                                                          "v-tab",
                                                          { key: "thread" },
                                                          [_vm._v("スレッド")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticStyle: {
                                                        "padding-right": "40px",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.schoolSetting &&
                                                    _vm.schoolSetting
                                                      .useAiChatGoal
                                                      ? _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "btn-new-chat",
                                                            attrs: {
                                                              icon: true,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.emitCreateThread(
                                                                  1
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "v-icon material-icons theme--dark",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "add_comment"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-tabs-items",
                                                  {
                                                    staticClass: "h-full",
                                                    model: {
                                                      value: _vm.tab,
                                                      callback: function ($$v) {
                                                        _vm.tab = $$v
                                                      },
                                                      expression: "tab",
                                                    },
                                                  },
                                                  [
                                                    _vm.schoolSetting
                                                      .useAiChatExam
                                                      ? _c(
                                                          "v-tab-item",
                                                          { key: "chat" },
                                                          [
                                                            _vm.userGoal.id &&
                                                            _vm.schoolSetting
                                                              .useAiChatGoal
                                                              ? _c(
                                                                  "MesageContainer",
                                                                  {
                                                                    key: _vm
                                                                      .userGoal
                                                                      .id,
                                                                    staticClass:
                                                                      "h-100",
                                                                    attrs: {
                                                                      targetableId:
                                                                        _vm
                                                                          .userGoal
                                                                          .id,
                                                                      targetableType:
                                                                        "UserGoal",
                                                                      "using-deepseek":
                                                                        _vm
                                                                          .schoolSetting
                                                                          .usingDeepSeek,
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.schoolSetting
                                                      .useAiChatExam
                                                      ? _c(
                                                          "v-tab-item",
                                                          { key: "thread" },
                                                          [
                                                            _c(
                                                              "ThreadContainer",
                                                              {
                                                                key: _vm.tabSelected,
                                                                staticClass:
                                                                  "h-full",
                                                                staticStyle: {
                                                                  height:
                                                                    "calc(76vh + 40px)",
                                                                },
                                                                attrs: {
                                                                  targetableId:
                                                                    _vm.tabSelected,
                                                                  targetableType:
                                                                    "UserGoal",
                                                                },
                                                                on: {
                                                                  updateParentTab:
                                                                    _vm.updateParentTab,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-white border border-primary rounded-3 mt-3 p-3",
                      },
                      _vm._l(
                        _vm.userGoal.milestones,
                        function (milestone, index) {
                          return _c("GoalMilestoneMobile", {
                            key: milestone.id,
                            attrs: {
                              milestone: milestone,
                              isFirst: index == 0,
                              isLast:
                                index == _vm.userGoal.milestones.length - 1,
                            },
                            on: {
                              "to-course": _vm.toCourse,
                              "to-exam": _vm.toExam,
                            },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "p-1 d-flex",
                    staticStyle: { "flex-wrap": "wrap" },
                  },
                  [
                    _c(
                      "multipane",
                      {
                        staticStyle: { flex: "1" },
                        attrs: { layout: "vertical" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: { width: "70%", "max-width": "100%" },
                          },
                          [
                            _c("GoalSummary", {
                              attrs: { userGoal: _vm.userGoal },
                            }),
                            _vm._v(" "),
                            _c("UserGoalSuggestion", {
                              staticClass: "mt-3",
                              attrs: { userGoal: _vm.userGoal },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "bg-white border border-primary rounded-3 mt-3 p-3",
                              },
                              _vm._l(
                                _vm.userGoal.milestones,
                                function (milestone, index) {
                                  return _c("GoalMilestoneWeb", {
                                    key: milestone.id,
                                    attrs: {
                                      milestone: milestone,
                                      isFirst: index == 0,
                                      isLast:
                                        index ==
                                        _vm.userGoal.milestones.length - 1,
                                    },
                                    on: {
                                      "to-course": _vm.toCourse,
                                      "to-exam": _vm.toExam,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("multipane-resizer", {
                          staticStyle: {
                            width: "2px",
                            border: "2px solid #e0e0e0",
                            margin: "0 5px",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "p-1",
                            staticStyle: { width: "30%", "flex-grow": "1" },
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [
                                _c(
                                  "v-tabs",
                                  {
                                    model: {
                                      value: _vm.tab,
                                      callback: function ($$v) {
                                        _vm.tab = $$v
                                      },
                                      expression: "tab",
                                    },
                                  },
                                  [
                                    _vm.userGoal.id &&
                                    _vm.schoolSetting.useAiChatGoal
                                      ? _c("v-tab", { key: "chat" }, [
                                          _vm._v("チャット"),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.userGoal.id &&
                                    _vm.schoolSetting.useAiChatGoal
                                      ? _c("v-tab", { key: "thread" }, [
                                          _vm._v("スレッド"),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { "padding-right": "40px" },
                                    }),
                                    _vm._v(" "),
                                    _vm.schoolSetting &&
                                    _vm.schoolSetting.useAiChatGoal
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass: "btn-new-chat",
                                            attrs: { icon: true },
                                            on: {
                                              click: function ($event) {
                                                return _vm.emitCreateThread(0)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              {
                                                staticClass:
                                                  "v-icon material-icons theme--dark",
                                              },
                                              [_vm._v("add_comment")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-tabs-items",
                                  {
                                    staticClass: "h-full",
                                    model: {
                                      value: _vm.tab,
                                      callback: function ($$v) {
                                        _vm.tab = $$v
                                      },
                                      expression: "tab",
                                    },
                                  },
                                  [
                                    _vm.schoolSetting.useAiChatExam
                                      ? _c(
                                          "v-tab-item",
                                          { key: "chat" },
                                          [
                                            _vm.userGoal.id &&
                                            _vm.schoolSetting.useAiChatGoal
                                              ? _c("MesageContainer", {
                                                  key: _vm.userGoal.id,
                                                  ref: "mesageContainer",
                                                  staticStyle: {
                                                    height: "83vh",
                                                  },
                                                  attrs: {
                                                    targetableId:
                                                      _vm.userGoal.id,
                                                    targetableType: "UserGoal",
                                                    "using-deepseek":
                                                      _vm.schoolSetting
                                                        .usingDeepSeek,
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.schoolSetting.useAiChatExam
                                      ? _c(
                                          "v-tab-item",
                                          { key: "thread" },
                                          [
                                            _c("ThreadContainer", {
                                              key: _vm.userGoal.id,
                                              staticStyle: { height: "83vh" },
                                              attrs: {
                                                targetableId: _vm.userGoal.id,
                                                targetableType: "UserGoal",
                                                parentTab: 0,
                                              },
                                              on: {
                                                updateParentTab:
                                                  _vm.updateParentTab,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "w-100",
        attrs: {
          "aria-label": "AIチャット",
          "data-bs-toggle": "modal",
          "data-bs-target": "#ai_chat",
        },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center fs-6",
          },
          [
            _c("span", { staticClass: "text-dark" }, [
              _vm._v("\n              AIチャット\n            "),
            ]),
            _vm._v(" "),
            _c("i", { staticClass: "bi bi-chevron-expand" }),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "div",
        { staticClass: "h5 mb-0 modal-title", attrs: { id: "ai_chatLabel" } },
        [_vm._v("\n                  AIチャット\n                ")]
      ),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }